import { ASSET_DATA_PROVIDERS as ASSET_PROVIDERS } from '@/pages/Assets/Assets.constants';

export const EMPTY_ASSET_DATA_PROVIDER_DIALOG = {
  api_token: '',
  base_url: '',
  machine_name: '',
  managed: false,
  provider: '',
  tenant_id: '',
  disabled: false
};

export const ASSET_DATA_PROVIDERS_OBJECT = [
  {
    id: 1,
    label: 'CrowdStrike',
    value: 'crowdstrike'
  },
  {
    id: 2,
    label: 'Manual Entry',
    value: 'manual'
  },
  {
    id: 3,
    label: 'Microsoft Defender',
    value: 'msdefender'
  },
  {
    id: 4,
    label: 'SentinelOne',
    value: 'sentinelone'
  },
  {
    id: 5,
    label: 'VMPE',
    value: 'vmpe'
  },
  {
    id: 6,
    label: 'SecuritySnares',
    value: 'securitysnares'
  }
];

export const ASSET_DATA_PROVIDER_DIALOG_LABELS = {
  [ASSET_PROVIDERS.CROWDSTRIKE]: {
    tenant_id: 'Client ID',
    base_url: 'Base URL',
    api_token: 'Client Secret'
  },
  [ASSET_PROVIDERS.SENTINELONE]: {
    tenant_id: 'Tenant ID',
    base_url: 'Base URL',
    api_token: 'API Token'
  },
  [ASSET_PROVIDERS.DEFENDER]: {
    tenant_id: 'Tenant ID',
    base_url: 'App ID',
    api_token: 'App Secret'
  },
  [ASSET_PROVIDERS.SECURITYSNARES]: {
    tenant_id: 'Tenant ID',
    base_url: 'Base URL',
    api_token: 'API Token'
  }
};

export const ASSET_DATA_PROVIDER_DIALOG_MACHINES = {
  sentinelone: [
    {
      id: 1,
      label: 'ponhq-sentinelone-usea1',
      value: 'ponhq-sentinelone-usea1'
    },
    {
      id: 2,
      label: 'ponhq-sentinelone-usea1-009',
      value: 'ponhq-sentinelone-usea1-009'
    }
  ]
};
